import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
    COMMUNITY_CONTRACT_LIST: {
        url: "gebruiker/get-communitycontract-list",
        method: "get",
    },

   SMS_HISTORY: (communityId) => ({
    url: `beheer/sent-sms-to-users?iCommunityId=${communityId}`,
    method: "get",
}),

    USERS_SMS_INFO: {
        url: "beheer/users-sms-info",
        method: "post",
    },

    SAVE_SMS: {
        url: "beheer/sms/save",
        method: "post",
    }
};

export const useCommunityContractList = () =>
    useApiFetcherSWR(API_ENDPOINT.COMMUNITY_CONTRACT_LIST);

export const useSmsHistory = (communityId) =>
    useApiFetcherSWR(
        communityId
            ? API_ENDPOINT.SMS_HISTORY(communityId)
            : null
    );

export const useUsersSmsInfo = () =>
    useApiFetcherSWR(API_ENDPOINT.USERS_SMS_INFO);

export const useSaveSms = () =>
    useApiFetcherSWR(API_ENDPOINT.SAVE_SMS);